import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Link} from '@travel-frontend/ui-components';

export const Container = styled(Link)(
  ({theme}) => css`
    display: flex;
    align-items: center;
    ${theme.typography.labelSmallBold};
    cursor: pointer;
    white-space: nowrap;
    background: transparent;
    border: 0;
    padding: 0;
  `
);
